import PropTypes from "prop-types";

function buildPath(data, width, height, strokeWidth) {
  if (!Array.isArray(data) || data.length === 0) return "";
  const pad = strokeWidth;
  const w = width - pad * 2;
  const h = height - pad * 2;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const step = data.length > 1 ? w / (data.length - 1) : 0;
  return data
    .map((v, i) => {
      const x = pad + i * step;
      const y = pad + h - ((v - min) / range) * h;
      return `${i === 0 ? "M" : "L"} ${x.toFixed(1)} ${y.toFixed(1)}`;
    })
    .join(" ");
}

export default function Sparkline({ data, color, width, height, strokeWidth }) {
  const d = buildPath(data, width, height, strokeWidth);
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      role="img"
      aria-label="sparkline"
    >
      <path
        d={d}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Sparkline.propTypes = {
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  strokeWidth: PropTypes.number,
};

Sparkline.defaultProps = {
  color: "var(--accent)",
  width: 108,
  height: 32,
  strokeWidth: 2,
};
